import { render, staticRenderFns } from "./sentOrder.vue?vue&type=template&id=0c3b8b14&"
import script from "./sentOrder.vue?vue&type=script&lang=js&"
export * from "./sentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports